import { connect } from 'react-redux';
import { Routes as RoutesComponent } from './routes.component';

export const Routes = connect(sState => ({ sState }))(RoutesComponent);